import React, { useState } from "react";
import { SidebarTrigger } from "../../components/ui/sidebar";
import { Bell, Mail } from "lucide-react";
import avatar from "./../assets/avatar-16.jpg";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu";
import { Link } from "react-router-dom";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover";
import { Separator } from "../../components/ui/separator";
import { FiLogOut } from "react-icons/fi";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "@radix-ui/react-dialog";
import { DialogFooter, DialogHeader } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";
import { toast, Toaster } from "sonner";

const Header = () => {
  const [darkMode, setDarkMode] = useState(false);
  const handleDarkMode = () => {
    setDarkMode(!darkMode);
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  };
  const [open, setOpen] = useState(false);

  const handlelogout = () => {
    localStorage.removeItem("adminToken");
    toast.success("Login successful!");
    window.location.href = "/admin/login";
    setOpen(false);
  };

  return (
    <>
      <Toaster />
      <div className="flex items-center py-2 border-b border-gray-200 w-full justify-between  z-50 my-3 shadow-md px-3 sticky top-1 bg-white">
        <div className="flex gap-1 items-center ">
          <SidebarTrigger />
        </div>
        <div className="flex items-center gap-2">
          {/* {
          darkMode ? <SunMoon onClick={handleDarkMode} /> : <Moon onClick={handleDarkMode} />
          } */}
          {/* <Bell className='w-12' /> */}

          <Popover>
            <PopoverTrigger>
              <Bell />
            </PopoverTrigger>
            <PopoverContent>
              <div className="space-y-4">
                <p className="flex gap-2 justify-start cursor-pointer hover:bg-gray-50 p-1">
                  <Mail className="size-12" />
                  <span className="text-[12px] font-light">
                    A new booking for Home cleaning & maintenance on 15th Nov
                    2024 has been successfully confirmed by provider John Doe.
                    Booking ID: 276398
                  </span>
                </p>
                <Separator />
                <p className="flex gap-2 justify-start cursor-pointer hover:bg-gray-50 p-1">
                  <Mail className="size-12" />
                  <span className="text-[12px] font-light">
                    A new booking for Home cleaning & maintenance on 15th Nov
                    2024 has been successfully confirmed by provider John Doe.
                    Booking ID: 276398
                  </span>
                </p>
                <Separator />
                <p className="flex gap-2 cursor-pointer hover:bg-gray-50 p-1">
                  <Mail className="size-12" />
                  <span className="text-[12px] font-normal ">
                    Booking ID: 276398 - provider John Doe has successfully
                    completed the service.
                  </span>
                </p>
                <Separator />
                <Link
                  to="/admin/notification"
                  className="flex justify-center items-center"
                >
                  {" "}
                  <span className="text-center text-gray-500 text-sm hover:font-bold hover:text-black">
                    View All
                  </span>
                </Link>
              </div>
            </PopoverContent>
          </Popover>
          {/* <div className="flex items-center py-2 border-b border-gray-200 w-full justify-between z-50 my-3 shadow-md px-3 sticky top-1 bg-white"> */}
          {/* Logout Icon - Toggles the modal */}
          <FiLogOut
            className="h-5 w-5 ml-3 cursor-pointer"
            onClick={() => setOpen(true)} // ✅ Opens modal when clicked
          />

          {/* Dialog Component */}
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent className="fixed inset-0 flex items-center justify-center bg-black/50">
              <div className="bg-white p-6 rounded-lg shadow-lg w-[400px]">
                <DialogHeader>
                  <DialogTitle className="text-lg font-bold">
                    Are you absolutely sure?
                  </DialogTitle>
                  <DialogDescription className="text-sm text-gray-600">
                    Are you sure you want to logout?
                  </DialogDescription>
                </DialogHeader>
                <DialogFooter className="flex justify-end mt-4">
                  <Button
                    type="button"
                    className="bg-gray-300 mr-2"
                    onClick={() => setOpen(false)} // ✅ Closes modal when clicked
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    className="bg-red-500 text-white"
                    onClick={handlelogout} // ✅ Closes modal when clicked
                  >
                    Logout
                  </Button>
                </DialogFooter>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </div>
    </>
  );
};

export default Header;
